export default "__VITE_ASSET__46857ac7__"